import React, { Component } from 'react';
import { getConfig } from '../../repositories';
import packageJson from '../../../../../package.json';

const { version } = packageJson;

class Version extends Component {

    state = {
        apiVersion: ''
    }

    componentDidMount = () => {

        getConfig().then( response => {

            this.setState( { apiVersion: response.apiVersion } );

        } );

    }

    render = () => (
        <span>
            {version} (API: {this.state.apiVersion})
        </span>
    );

}

Version.displayName = 'Version';

export default Version;
